import { render, staticRenderFns } from "./oneServiceRecord.vue?vue&type=template&id=6d990fd8&scoped=true"
import script from "./oneServiceRecord.vue?vue&type=script&lang=js"
export * from "./oneServiceRecord.vue?vue&type=script&lang=js"
import style0 from "./oneServiceRecord.vue?vue&type=style&index=0&id=6d990fd8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d990fd8",
  null
  
)

export default component.exports